export const Config = {
  version: process.env.VUE_APP_VERSION,
  env: process.env.NODE_ENV,
  mode: process.env.VUE_APP_ENV,
  api: {
    auth: {
      url: process.env.VUE_APP_API_AUTH,
      refreshTokenInterval: 10 * 60 * 1000, // 10 minutes
    },
    tender: {
      url: process.env.VUE_APP_API_TENDER,
    },
    document: {
      url: process.env.VUE_APP_API_DOCUMENT,
    },
    slipExtractor: {
      url: process.env.VUE_APP_API_SLIP_EXTRACTOR,
    },
    bi: {
      url: process.env.VUE_APP_API_BI_READER, // old BI service - still in use for BI Charts display
    },
    businessIntelligence: {
      url: process.env.VUE_APP_API_BI,
    },
    notification: {
      url: process.env.VUE_APP_API_NOTIFICATION,
    },
    tenantSettings: {
      url: process.env.VUE_APP_TENANT_SETTINGS,
    },
    aiModules: {
      url: process.env.VUE_APP_API_AI_MODULES,
    },
  },
  i18n: {
    defaultLocale: process.env.VUE_APP_I18N_DEFAULT_LOCALE,
  },
  helpCenter: {
    fr: 'https://help.aloha.app/',
    en: 'https://help-en.aloha.app/',
  },
  website: {
    fr: 'https://www.aloha.app/',
    en: 'https://www.aloha.app/',
  },
  terms: {
    fr: 'https://www.aloha.app/legal',
    en: 'https://www.aloha.app/legal',
  },
  contact: 'https://aloha.app/contact',
  // Unset on the web, where shared links use the page's own origin. Set by the
  // desktop build (aloha.desktop.shell) — see src/models/tenders.js.
  shareBaseUrl: process.env.VUE_APP_SHARE_BASE_URL,
  beacon: {
    fr: process.env.VUE_APP_BEACON_FR,
    en: process.env.VUE_APP_BEACON_EN,
  },
  sentry: process.env.VUE_APP_SENTRY,
  gtag: process.env.VUE_APP_GTAG,
  clarity: process.env.VUE_APP_CLARITY,
  mapbox: {
    publicKey: process.env.VUE_APP_MAPBOX_PUBLIC_KEY,
  },
};

export const isProduction = () => {
  return Config.env === 'production';
};

export const isDevelopment = () => {
  return Config.env !== 'production';
};
